/**
 * Shopify privacy/cookie banner: conserva el fondo compacto y legible incluso
 * cuando Shopify vuelve a insertar el diálogo.
 */
(function () {
  var BG = 'rgba(16, 15, 20, 0.94)';
  var STYLE_ID = 'clash-cookie-banner-solid';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      '#shopify-pc__banner, .shopify-pc__banner,',
      '#shopify-pc__banner__wrapper, .shopify-pc__banner__wrapper {',
      '  background: transparent !important;',
      '  border: 0 !important;',
      '  box-shadow: none !important;',
      '}',
      '#shopify-pc__banner .shopify-pc__banner__dialog,',
      '.shopify-pc__banner__dialog,',
      '#shopify-pc__banner__dialog {',
      '  background: ' + BG + ' !important;',
      '  box-sizing: border-box !important;',
      '  width: min(420px, calc(100vw - 24px)) !important;',
      '  max-width: calc(100vw - 24px) !important;',
      '  max-height: calc(100vh - 24px) !important;',
      '  overflow: auto !important;',
      '  margin: 12px !important;',
      '  padding: 18px 20px !important;',
      '  border: 1px solid rgba(255,255,255,0.12) !important;',
      '  border-radius: 18px !important;',
      '  box-shadow: 0 12px 36px rgba(0,0,0,0.36) !important;',
      '  backdrop-filter: blur(18px) saturate(125%) !important;',
      '  -webkit-backdrop-filter: blur(18px) saturate(125%) !important;',
      '}',
      '#shopify-pc__banner .shopify-pc__banner__dialog p,',
      '.shopify-pc__banner__dialog p,',
      '.shopify-pc__banner__dialog span {',
      '  color: rgba(243,243,245,0.92) !important;',
      '  font-size: 13px !important;',
      '  line-height: 1.45 !important;',
      '}',
      '#shopify-pc__banner .shopify-pc__banner__dialog h2,',
      '.shopify-pc__banner__dialog h2 {',
      '  margin: 0 0 8px !important;',
      '  font-size: 16px !important;',
      '  line-height: 1.3 !important;',
      '}',
      '#shopify-pc__banner .shopify-pc__banner__btns,',
      '.shopify-pc__banner__btns {',
      '  gap: 8px !important;',
      '  margin-top: 12px !important;',
      '}',
      '#shopify-pc__banner .shopify-pc__banner__btns button,',
      '.shopify-pc__banner__btns button {',
      '  min-height: 38px !important;',
      '  padding: 8px 14px !important;',
      '  border-radius: 999px !important;',
      '  font-size: 12px !important;',
      '}',
      '#shopify-pc__prefs__dialog, .shopify-pc__prefs__dialog {',
      '  background: ' + BG + ' !important;',
      '  border: 1px solid rgba(255,255,255,0.12) !important;',
      '  border-radius: 18px !important;',
      '  box-shadow: 0 16px 48px rgba(0,0,0,0.45) !important;',
      '  backdrop-filter: blur(18px) saturate(125%) !important;',
      '  -webkit-backdrop-filter: blur(18px) saturate(125%) !important;',
      '}'
    ].join('\n');
    document.documentElement.appendChild(s);
  }

  function paint(el, compact) {
    if (!el || el.nodeType !== 1) return;
    el.style.setProperty('background', BG, 'important');
    el.style.setProperty('background-color', BG, 'important');
    el.style.setProperty('background-image', 'none', 'important');
    el.style.setProperty('opacity', '1', 'important');
    if (compact) {
      el.style.setProperty('box-sizing', 'border-box', 'important');
      el.style.setProperty('width', 'min(420px, calc(100vw - 24px))', 'important');
      el.style.setProperty('max-width', 'calc(100vw - 24px)', 'important');
      el.style.setProperty('max-height', 'calc(100vh - 24px)', 'important');
      el.style.setProperty('overflow', 'auto', 'important');
      el.style.setProperty('margin', '12px', 'important');
      if (window.matchMedia('(max-width: 600px)').matches) {
        el.style.setProperty('position', 'fixed', 'important');
        el.style.setProperty('top', 'auto', 'important');
        el.style.setProperty('right', 'auto', 'important');
        el.style.setProperty('bottom', '12px', 'important');
        el.style.setProperty('left', '50%', 'important');
        el.style.setProperty('transform', 'translateX(-50%)', 'important');
        el.style.setProperty('margin', '0', 'important');
      } else {
        el.style.setProperty('position', 'fixed', 'important');
        el.style.setProperty('top', 'auto', 'important');
        el.style.setProperty('right', 'auto', 'important');
        el.style.setProperty('bottom', '12px', 'important');
        el.style.setProperty('left', '50%', 'important');
        el.style.setProperty('transform', 'translateX(-50%)', 'important');
        el.style.setProperty('margin', '0', 'important');
      }
      el.style.setProperty('padding', '18px 20px', 'important');
      el.style.setProperty('border', '1px solid rgba(255,255,255,0.12)', 'important');
      el.style.setProperty('border-radius', '18px', 'important');
      el.style.setProperty('box-shadow', '0 12px 36px rgba(0,0,0,0.36)', 'important');
      el.style.setProperty('backdrop-filter', 'blur(18px) saturate(125%)', 'important');
      el.style.setProperty('-webkit-backdrop-filter', 'blur(18px) saturate(125%)', 'important');
    } else {
      el.style.setProperty('border', '1px solid rgba(255,255,255,0.12)', 'important');
      el.style.setProperty('border-radius', '18px', 'important');
      el.style.setProperty('box-shadow', '0 16px 48px rgba(0,0,0,0.45)', 'important');
      el.style.setProperty('backdrop-filter', 'blur(18px) saturate(125%)', 'important');
      el.style.setProperty('-webkit-backdrop-filter', 'blur(18px) saturate(125%)', 'important');
    }
  }

  function styleBanner() {
    ensureStyle();
    document
      .querySelectorAll(
        '#shopify-pc__banner__dialog, .shopify-pc__banner__dialog, #shopify-pc__prefs__dialog, .shopify-pc__prefs__dialog'
      )
      .forEach(function (el) {
        paint(el, el.matches('#shopify-pc__banner__dialog, .shopify-pc__banner__dialog'));
      });
  }

  function boot() {
    styleBanner();
    new MutationObserver(styleBanner).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    [200, 800, 2000, 4000].forEach(function (ms) {
      setTimeout(styleBanner, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
